import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import i18n from '../i18n';
import api from '../services/api';
import {
  generateGroupKey,
  encryptGroupField,
  wrapGroupKeyForSelf,
} from '../services/signalGroupCrypto';

function CreateDiscussion({ onDiscussionCreated, onOpenDiscussion, prompt, showForm, setShowForm }) {
  const [discussionName, setDiscussionName] = useState('');
  const { t } = useTranslation();
  const navigate = useNavigate();
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (discussionName.trim() === '') return;

    try {
      const token = localStorage.getItem('token');

      // 🔒 E2EE — génère la clé de groupe, chiffre le titre, l'enveloppe pour soi-même.
      // Le serveur ne verra jamais le titre en clair pour une discussion privée.
      const groupKeyRaw = await generateGroupKey();
      const titleEncrypted = await encryptGroupField(discussionName, groupKeyRaw);
      const selfWrap = await wrapGroupKeyForSelf(groupKeyRaw);

      const response = await api.post(
        `${API_URL}/api/discussions/create`,
        {
          titleCiphertext: titleEncrypted.ciphertext,
          titleIv: titleEncrypted.iv,
          selfWrapEncryptedKey: selfWrap.encryptedKey,
          selfWrapKeyIv: selfWrap.keyIv,
        },
        { headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` } }
      );

      // Le serveur renvoie le titre encore chiffré (il ne peut pas le lire),
      // mais le wrap self qu'on vient de créer permet un déchiffrement local
      // quasi instantané — pas besoin d'injecter le texte en clair ici,
      // ça éviterait même un conflit avec le pipeline de déchiffrement normal
      // (qui s'attend à { ciphertext, iv }, pas à une string).
      const newDiscussion = response.data;

      onDiscussionCreated(newDiscussion);
      setShowForm(false);
      setDiscussionName('');

      const { confirm } = prompt;
      const confirmed = await confirm(t('creatediscussion.confirm_creation'));
      if (confirmed) {
        onOpenDiscussion(newDiscussion);
      }
    } catch (error) {
      console.error('Erreur lors de la création de la discussion', error);
    }
  };

  return (
    <form className="creatediscussion-modal" onSubmit={handleSubmit}>
      <p className="creatediscussion-title">{t('creatediscussion.startdiscussion')}</p>
      <input
        type="text"
        value={discussionName}
        onChange={(e) => setDiscussionName(e.target.value)}
        placeholder={t('profile.name')}
        required
        autoFocus
        className="creatediscussion-input"
      />
      <div className="creatediscussion-actions">
        <button
          type="button"
          className="creatediscussion-cancel"
          onClick={() => setShowForm(false)}
        >
          {t('diffusion.comments_cancel')}
        </button>
        <button type="submit" className="creatediscussion-submit">
          <i className="ti ti-plus" aria-hidden="true" />
          {t('creatediscussion.start')}
        </button>
      </div>
    </form>
  );
}

export default CreateDiscussion;
